<template lang="pug">
 v-dialog(max-width='500px' v-model='mode.productDialog' persistent scrollable transition='dialog-left-transition')
  v-card
    v-card-title.headline.grey.lighten-2.pa-1(primary-title)
      | ({{editedItem.counterCode || &apos;Group&apos;}}){{formTitle(&apos;Product&apos;)}}
      v-icon(v-if='editedItem.isFav' color='yellow') mdi-star
    v-card-text.pa-1
      v-form.pa-1(ref='product')
        v-form-base#productForm(:value='editedItem' :schema='schema' @input:productForm='onFormInput')
          v-content.pa-0.pb-3(slot='slot-bottom-key-taxPlan')
            div(v-if='editedItem.taxPlan')
              v-row.pb-0(v-for='c in taxPlans.filter(t=>t.code===editedItem.taxPlan)[0].components' :key='c.code')
                v-col.pa-0
                  small(style='color:blue')
                    | {{&grave;${c.name} (${c.code}) @ &grave;}}
                    span(style='color:red') {{&grave;${c.rate}%&grave;}}
          v-content.pa-0.pb-3(slot='slot-item-key-tags')
            v-row
              v-col.pa-0
                v-menu(offset-y)
                  template(v-slot:activator='{ on }')
                    small Tags:
                    code(v-on.stop='on') {{editedItem.tags.join(&apos;,&apos;) || &apos;Select tags&apos;}}
                  v-list
                    v-list-item(v-for="t in selectedGroup.productTags.split(',')" :key='t' @click='vibrate();updateTags(t)')
                      strong(v-if='editedItem.tags.includes(t)') {{ t }}
                      span(v-else) {{ t }}
          v-content(slot='slot-item-key-imageUrl')
            v-dialog(persistent v-model='cameraDialog' transition='scale-transition' origin='center center')
              template(v-slot:activator='{ on }')
                img.imageBox(alt='Product Image' :src="editedItem.imageUrl || '/images/touch_here.png'" v-on='on')
              v-card(align='center')
                v-card-title
                  .v-toolbar__title Capture Photo
                v-divider
                v-card-text
                  croppa(v-model='myCroppa' :width='225' :height='225' :outputwidth='225' :outputheight='225' :placeholder="'Click or Tap here'" :placeholder-font-size='20' :quality='3' canvas-color='transparent')
                v-divider
                v-card-actions
                  v-spacer
                  v-btn(color='blue darken-1' text @click='cameraDialog = false') Cancel
                  v-btn(color='blue darken-1' text @click='uploadImage') Upload
            v-icon(v-if='editedItem.imageUrl' @click='clearImage()' color='red') mdi-close
    v-divider
    v-card-actions
      v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.ACTIVE && editedItem.isGroupProduct' :disabled='isDirty' text v-on:click.stop='deActivate(dialogKey)') De-Activate
      v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.ACTIVE && !editedItem.isGroupProduct' :disabled='selectedRestaurant.status!==STATUSES.ACTIVE' text v-on:click.stop='deleteItem(dialogKey)') Delete
      v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.INACTIVE && editedItem.isGroupProduct' :disabled='isDirty' text v-on:click.stop='editedItem.status=STATUSES.ACTIVE;save(dialogKey)') Activate
      v-spacer
      v-btn(color='primary' v-if='isDirty' text v-on:click.stop='cancel(dialogKey)') Cancel
      v-btn(color='primary' v-if='!isDirty' text v-on:click.stop='cancel(dialogKey)') Close
      v-btn(color='primary' :disabled='!isDirty && editedItem.id!=null' text v-on:click.stop='save(dialogKey)') Save

</template>

<script>
import { dialogsMixin } from "../../mixins/dialogsMixin.js";
import { storeMixin } from "../../mixins/storeMixin.js";
import { taxPlans } from "../../config/taxPlans.js";
import { storage } from "../../config/db.js";

export default {
  name: "product-dialog",
  mixins: [storeMixin, dialogsMixin],
  data() {
    return {
      collectionName: "products",
      dialogKey: "productDialog",
      myCroppa: {},
      cameraDialog: false,
      originalTags: null,
      defaultItem: {
        name: "",
        rate: "",
        taxPlan: "",
        managerFee: "1.0",
        supervisorFee: "1.0",
        waiterFee: "1.0",
        helperFee: "1.0",
        chefFee: "1.0",
        count: "",
        desc: "",
        status: 0,
        tags: [],
        imageUrl: null
      },
      taxPlans: taxPlans
    };
  },
  computed: {
    incentiveDisabled() {
      return !this.myFeatures.eligibleFeatures.includes("INCENTIVE");
    },
    schema() {
      return Object.assign(
        {
          _groupKey: { type: "text", hidden: true },
          _restaurantKey: { type: "text", hidden: true },
          _counterKey: { type: "text", hidden: true },
          isGroupProduct: { type: "text", hidden: true },
          isFav: { type: "text", hidden: true },
          code: {
            type: "text",
            label: "Code",
            flex: 2,
            sort: 1,
            rules: [
              this.required("Product Code is required"),
              this.minLen(2),
              this.maxLen(8)
            ],
            disabled: true
          },
          name: {
            type: "text",
            label: "Product Name",
            flex: 9,
            offset: 1,
            sort: 2,
            rules: [
              this.required("Product Name is required"),
              this.minLen(10),
              this.maxLen(40)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          counterCode: {
            type: "select",
            items: this.myCounters.map(c => c.code),
            label: "Counter",
            flex: 6,
            sort: 3,
            hidden: this.editedItem.isGroupProduct ? true : false
          },
          count: {
            type: "text",
            label: this.editedItem.isGroupProduct ? "" : "Count",
            flex: 2,
            offset: 1,
            sort: 4,
            rules: [
              this.required("Remaining count is required"),
              this.maxLen(3)
            ],
            hidden:
              !this.myFeatures.eligibleFeatures.includes("INVENTORY") ||
              this.editedItem.isGroupProduct
          },
          imageUrl: {
            type: "text",
            flex: 12,
            sort: 5
          },
          rate: {
            type: "text",
            label: "Rate",
            flex: 4,
            sort: 6,
            rules: [
              this.required("Rate is required"),
              this.minLen(1),
              this.maxLen(6)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          taxPlan: {
            type: "select",
            label: "Tax Plan",
            items: this.taxPlans.map(t => t.code),
            flex: 6,
            offset: 1,
            sort: 7,
            rules: [this.required("Tax Plan is required")],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          managerFee: {
            type: "text",
            label: "Manager fee",
            flex: 3,
            sort: 8,
            hidden: this.incentiveDisabled,
            rules: [
              this.required("Manager fee is required"),
              this.minLen(1),
              this.maxLen(6)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          chefFee: {
            type: "text",
            label: "Chef fee",
            flex: 3,
            sort: 9,
            offset: 1,
            hidden: this.incentiveDisabled,
            rules: [
              this.required("Chef fee is required"),
              this.minLen(1),
              this.maxLen(6)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          waiterFee: {
            type: "text",
            label: "Waiter fee",
            flex: 3,
            offset: 1,
            sort: 10,
            hidden: this.incentiveDisabled,
            rules: [
              this.required("Waiter fee is required"),
              this.minLen(1),
              this.maxLen(6)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          helperFee: {
            type: "text",
            label: "Helper fee",
            flex: 3,
            sort: 11,
            hidden: this.incentiveDisabled,
            rules: [
              this.required("Helper fee is required"),
              this.minLen(1),
              this.maxLen(6)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          supervisorFee: {
            type: "text",
            label: "Supervisor fee",
            flex: 3,
            offset: 1,
            sort: 12,
            hidden: this.incentiveDisabled,
            rules: [
              this.required("Supervisor fee is required"),
              this.minLen(1),
              this.maxLen(6)
            ],
            disabled: !["GA"].includes(this.selectedUser.role)
          },
          status: {
            type: "select",
            label: "Status",
            items: ["Draft", "Active"],
            flex: 3,
            offset: this.incentiveDisabled ? 0 : 1,
            sort: 13,
            rules: [this.required("Status is required")],
            hidden: true
          },
          tags: {
            type: "textarea",
            label: "Tags",
            flex: 12,
            sort: 14
          },
          desc: {
            type: "textarea",
            label: "Description",
            flex: 12,
            sort: 15,
            rules: [this.maxLen(200)]
          }
        },
        this.baseSchema
      );
    }
  },
  methods: {
    updateTags(tag) {
      const product = this.editedItem;
      if (!this.originalTags) {
        this.originalTags = Object.assign([], product.tags);
      }
      const index = product.tags.indexOf(tag);
      if (index != -1) {
        product.tags.splice(index, 1);
      } else {
        product.tags.push(tag);
      }
      this.isDirty = true;
    },
    uploadImage: function() {
      const storageRef = storage.ref();
      const productRef = storageRef.child(
        `images/groups/${this.selectedGroup.id}/products/${this.editedItem.id}/${this.editedItem.code}.png`
      );
      this.myCroppa.generateBlob(
        blob => {
          productRef.put(blob).then(snapshot => {
            snapshot.ref.getDownloadURL().then(url => {
              //alert("Uploaded a blob or file!" + url);
              this.editedItem.imageUrl = url;
              this.cameraDialog = false;
              this.isDirty = true;
            });
          });
        },
        "image/jpeg",
        0.1
      );
    },
    clearImage() {
      this.editedItem.imageUrl = "";
      this.isDirty = true;
      this.$forceUpdate();
    },
    onFormInput(event) {
      this.isDirty = true;
      if (event.key === "counterCode") {
        this.editedItem._counterKey = this.myCounters.find(
          c => c.code === event.value
        ).id;
      }
      return event;
    },
    async cancel(dialogStr) {
      if (
        !this.isDirty ||
        (await this.$confirm("Are you sure you want to cancel without save?"))
      ) {
        if (this.originalTags) {
          this.editedItem.tags.length = 0;
          this.originalTags.forEach(t => this.editedItem.tags.push(t));
        }
        this.mode[dialogStr] = false;
      }
    }
  }
};
</script>
<style>
.imageBox {
  width: 225px;
  border: 1px solid;
  border-radius: 8px;
}
</style>